/* ============================================================
   VIVĀRA — THE JOURNAL (horizontal rail)
   ------------------------------------------------------------
   A film strip rather than a grid: every tile is the same height,
   so mixed portrait and landscape material sits on one baseline and
   twenty-seven pieces cost the page one screen of height instead of
   twenty. It scrolls with the wheel, a drag, the arrow keys, or a
   finger.

   Film is silent and stays silent:
     · the encoded files carry no audio track at all
     · the element is muted, has no controls, and no context menu
     · muted is re-asserted on every play and on any volume change
     · picture-in-picture and remote playback are disabled
   There is nothing for a visitor to turn on.

   Playback is tied to visibility — a film only runs while it is on
   screen — and is disabled entirely under prefers-reduced-motion,
   where the poster frame stands in.

   SHOPIFY MIGRATION → assets/vivara-journal.js, rendered by
   sections/vivara-home.liquid. Files resolve through
   window.VIVARA_ASSET_ROOT, so the flat assets folder works.
   ============================================================ */
(function () {
  "本ポリシーはVIVĀRAで直接ご注文いただいた場合に適用され、お客様の法律上の権利を妨げるものではありません。";

  var DIR = "assets/img/journal/";
  var VDIR = "assets/video/";

  function base() {
    return document.documentElement.getAttribute("data-base") || "";
  }
  function imgUrl(file) {
    return window.VIVARA_ASSET_ROOT ? window.VIVARA_ASSET_ROOT + file : base() + DIR + file;
  }
  function vidUrl(file) {
    return window.VIVARA_ASSET_ROOT ? window.VIVARA_ASSET_ROOT + file : base() + VDIR + file;
  }

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function silence(v) {
    v.muted = true;
    v.volume = 0;
    v.defaultMuted = true;
  }

  function videoNode(item) {
    var v = document.createElement("video");
    silence(v);
    v.loop = true;
    v.playsInline = true;
    v.setAttribute("playsinline", "");
    v.setAttribute("webkit-playsinline", "");
    v.setAttribute("muted", "");
    v.setAttribute("disablepictureinpicture", "");
    v.setAttribute("disableremoteplayback", "");
    v.controls = false;
    v.preload = "none";
    v.poster = imgUrl(item.poster);
    v.width = item.w;
    v.height = item.h;
    v.src = vidUrl(item.src);
    /* Belt and braces: the file has no audio track, but if anything ever
       tries to raise the volume it is put straight back. */
    v.addEventListener("volumechange", function () {
      if (!v.muted || v.volume !== 0) silence(v);
    });
    v.addEventListener("play", function () { silence(v); });
    v.addEventListener("contextmenu", function (e) { e.preventDefault(); });
    return v;
  }

  function build(rail) {
    var items = window.VIVARA_JOURNAL || [];
    if (!items.length) {
      var section = rail.closest("section");
      if (section) section.remove();
      return;
    }

    var videos = [];

    items.forEach(function (item, i) {
      var fig = document.createElement("figure");
      fig.className = "journal-item";
      /* The tile's width follows the media's own ratio at a fixed height,
         and is declared up front so nothing moves as images arrive. */
      fig.style.setProperty("--ratio", (item.w / item.h).toFixed(4));

      var media;
      if (item.type === "video") {
        fig.classList.add("journal-item--film");
        media = videoNode(item);
        videos.push(media);
      } else {
        media = document.createElement("img");
        media.src = imgUrl(item.src);
        media.alt = item.caption ? item.caption + " — VIVĀRA" : "";
        media.width = item.w;
        media.height = item.h;
        media.loading = i < 3 ? "eager" : "lazy";
        media.decoding = "async";
        media.draggable = false;
      }
      media.className = "journal-media";
      media.draggable = false;
      fig.appendChild(media);

      if (item.caption) {
        var cap = document.createElement("figcaption");
        cap.className = "journal-caption";
        cap.innerHTML = '<span class="journal-index">' +
          String(i + 1).padStart(2, "0") + "</span><span>" + item.caption + "</span>";
        fig.appendChild(cap);
      }

      rail.appendChild(fig);
    });

    /* A film runs only while it is on screen, and never under reduced motion. */
    if (!reduced && videos.length && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            silence(v);
            if (v.preload === "none") v.preload = "auto";
            var p = v.play();
            if (p && p.catch) p.catch(function () { /* poster stands in */ });
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { root: rail, threshold: 0.35 });
      videos.forEach(function (v) { io.observe(v); });
    }

    wire(rail);
  }

  /* ---------- rail behaviour ---------- */
  function wire(rail) {
    var progress = document.querySelector("[data-journal-progress]");

    function report() {
      if (!progress) return;
      var max = rail.scrollWidth - rail.clientWidth;
      var pct = max > 0 ? (rail.scrollLeft / max) : 0;
      progress.style.setProperty("--p", pct.toFixed(4));
    }
    rail.addEventListener("scroll", report, { passive: true });
    window.addEventListener("resize", report);
    report();

    /* Drag to pan, on a pointer that is not a touch screen (touch already
       scrolls natively, and hijacking it makes the rail feel wrong).

       The catch: an <img> is natively draggable, so pressing on a photograph
       started the browser's own drag-and-drop, which cancels the pointer
       stream — the rail never saw a single pointermove and nothing happened.
       The default is refused on the way down, the pointer is captured so the
       stream survives leaving the element, and a cancel resets the state. */
    var down = false, startX = 0, startLeft = 0, moved = 0;

    rail.addEventListener("dragstart", function (e) { e.preventDefault(); });

    rail.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "touch" || e.button !== 0) return;
      e.preventDefault();
      down = true; moved = 0;
      startX = e.clientX; startLeft = rail.scrollLeft;
      rail.classList.add("is-grabbing");
      if (rail.setPointerCapture) {
        try { rail.setPointerCapture(e.pointerId); } catch (err) { /* older engines */ }
      }
    });

    function pan(e) {
      if (!down) return;
      var dx = e.clientX - startX;
      moved = Math.max(moved, Math.abs(dx));
      rail.scrollLeft = startLeft - dx;
    }
    rail.addEventListener("pointermove", pan);
    window.addEventListener("pointermove", pan);

    function release(e) {
      if (!down) return;
      down = false;
      rail.classList.remove("is-grabbing");
      if (e && e.pointerId != null && rail.releasePointerCapture) {
        try { rail.releasePointerCapture(e.pointerId); } catch (err) { /* already gone */ }
      }
    }
    rail.addEventListener("pointerup", release);
    rail.addEventListener("pointercancel", release);
    window.addEventListener("pointerup", release);
    window.addEventListener("blur", function () { release(null); });

    /* Keyboard: the rail is focusable, so arrows page through it. */
    rail.addEventListener("keydown", function (e) {
      var step = Math.max(260, rail.clientWidth * 0.7);
      if (e.key === "ArrowRight") { rail.scrollBy({ left: step, behavior: reduced ? "auto" : "smooth" }); e.preventDefault(); }
      if (e.key === "ArrowLeft") { rail.scrollBy({ left: -step, behavior: reduced ? "auto" : "smooth" }); e.preventDefault(); }
    });

    document.querySelectorAll("[data-journal-step]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var dir = btn.getAttribute("data-journal-step") === "prev" ? -1 : 1;
        rail.scrollBy({ left: dir * Math.max(260, rail.clientWidth * 0.7),
                        behavior: reduced ? "auto" : "smooth" });
      });
    });
  }

  function init() {
    var rail = document.querySelector("[data-journal-rail]");
    if (rail) build(rail);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
